import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function AddNewAgencyOfficials() {
  const { id: renew_id } = useParams(); // get renew_id from URL

  const [formData, setFormData] = useState({
    renew_officials_name: '',
    renew_officials_designation: '',
    renew_officials_phone: '',
    renew_officials_email: '',
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // ✅ Validation
  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.renew_officials_designation.trim()) {
      tempErrors.renew_officials_designation = 'Designation is required.';
      isValid = false;
    }
    if (!formData.renew_officials_name.trim()) {
      tempErrors.renew_officials_name = "Official's Name is required.";
      isValid = false;
    }
    if (formData.renew_officials_email && !/\S+@\S+\.\S+/.test(formData.renew_officials_email)) {
      tempErrors.renew_officials_email = 'Enter a valid email address.';
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  // ✅ Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      await axios.post(`https://backend-zkgn.onrender.com/api/renewable-agency-officials/add/${renew_id}`, {
        renew_id,
        ...formData,
      });

      setSuccessMessage('Renewable Agency Official Added Successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);

      // reset form
      setFormData({
        renew_officials_name: '',
        renew_officials_designation: '',
        renew_officials_phone: '',
        renew_officials_email: '',
      });
    } catch (error) {
      console.error('Error submitting form:', error.message);
    }
  };

  return (
    <div className="container my-5">
      <h4 className="mb-4 text-center">Add Renewable Agency Official</h4>

      {successMessage && (
        <div className="alert alert-success text-center" role="alert">
          {successMessage}
        </div>
      )}

      <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
        <div className="row g-3">
          {/* Designation */}
          <div className="col-md-6">
            <label className="form-label">Designation</label>
            <input
              type="text"
              className="form-control"
              name="renew_officials_designation"
              value={formData.renew_officials_designation}
              onChange={handleChange}
            />
            {errors.renew_officials_designation && (
              <small className="text-danger">{errors.renew_officials_designation}</small>
            )}
          </div>

          {/* Official Name */}
          <div className="col-md-6">
            <label className="form-label">Official's Name</label>
            <input
              type="text"
              className="form-control"
              name="renew_officials_name"
              value={formData.renew_officials_name}
              onChange={handleChange}
            />
            {errors.renew_officials_name && (
              <small className="text-danger">{errors.renew_officials_name}</small>
            )}
          </div>

          {/* Email */}
          <div className="col-md-6">
            <label className="form-label">Official's Email (Optional)</label>
            <input
              type="email"
              className="form-control"
              name="renew_officials_email"
              value={formData.renew_officials_email}
              onChange={handleChange}
            />
            {errors.renew_officials_email && (
              <small className="text-danger">{errors.renew_officials_email}</small>
            )}
          </div>

          {/* Phone */}
          <div className="col-md-6">
            <label className="form-label">Phone Number (Optional)</label>
            <input
              type="text"
              className="form-control"
              name="renew_officials_phone"
              value={formData.renew_officials_phone}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Submit */}
        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary px-4">
            Add Renewable Agency Official
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddNewAgencyOfficials;
